// IELTS Mock 3 — Academic Speaking
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK3_SPEAKING = {
  title: "Academic Speaking Practice Test 3",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about your work or studies. Do you work, or are you a student?",
        "What do you enjoy most about your job or your course?",
        "Let's talk about weekends. What do you usually do at the weekend?",
        "Do you prefer to spend your weekends at home or going out? Why?",
        "Has the way you spend your weekends changed since you were a child?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a useful skill you learned outside school or university. You should say: What the skill is, When and where you learned it, Who helped you to learn it, and explain why this skill is useful to you.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "What skills do you think are most important for young people to learn today?",
        "Is it better to learn a new skill from a teacher or by yourself, for example online? Why?",
        "Should schools teach more practical skills, such as cooking or managing money?",
        "How might the skills people need for work change in the future?"
      ]
    }
  ]
};

export default IELTS_MOCK3_SPEAKING;
